<template>
  <transition name="fade">
    <div class="app-signup" v-if="visible">
      <div class="app-signup__mask" @click.self="onVisibleChange"></div>
      <div class="app-signup-container" :class="{ complete: complete }">
        <span class="app-signup__close" @click.self="onVisibleChange"></span>
        <div class="box">
          <div v-if="!complete">
            <img
              src="../../assets/title-signup@1x.png"
              srcset="../../assets/title-signup@2x.png 2x"
              class="app-signup__topic"
            />

            <div class="form">
              <div class="form-item">
                <span class="form-item__label">
                  <span style="color:#e3b3ab; margin-right: 2px;">*</span>姓{{" "}}{{" "}}{{" "}}{{" "}}{{" "}}名:
                </span>
                <div class="form-item__control">
                  <input
                    type="text"
                    v-model="name"
                    placeholder="请输入姓名"
                    autocomplete="new-password"
                  />
                </div>
              </div>
              <div class="form-item">
                <span class="form-item__label">
                  <span style="color:#e3b3ab; margin-right: 2px">*</span>联系电话:
                </span>
                <div class="form-item__control">
                  <input
                    type="text"
                    v-model="phone"
                    placeholder="请输入个人联系电话"
                    autocomplete="new-password"
                  />
                </div>
              </div>
            </div>

            <div class="app-signup__tip">
              <span
                class="app-signup__tip__checkbox"
                :class="{ 'app-signup__tip__checkbox--checked': checked }"
                @click="onCheckboxChange"
              ><i></i></span>
              <span>
                我已阅读并完全同意
                <a href="./protocol.html?focus=procotol" target="_blank">《大赛用户服务协议》</a>和
                <a href="./protocol.html?focus=policy" target="_blank">《隐私权政策》</a>
              </span>
            </div>

            <div class="btn-wrap" style="text-align: center; position: relative">
              <button class="app-signup__btn" @click="submit">
                <span>立即参赛</span>
              </button>
              <!-- <button class="app-signup__btn app-signup__btn-login" >
                <span>已报名，点此登录</span>
              </button> -->
              <span v-show="!user" class="app-signup__btn-login" @click="showLogin">
                已报名，点此登录 <img src="../../assets/icon-next.png" width="14">
              </span>
            </div>

            
          </div>

          <transition name="fade">
            <div v-if="complete">
              <div class="app-signup-flow">
                <img src="../../assets/topic-title-flow.png" class="app-signup__topic" />
                <ul>
                  <li
                    v-for="(item, i) in steps"
                    :key="item.title"
                    :class="{ done: item.done }"
                  >
                    <span 
                      :class="{
                        'order-num': !item.done,
                        'icon-done': item.done
                      }"

                    >
                      {{ item.done ? '' : i + 1 }}
                    </span>
                    <div>
                      <div class="title" v-html="item.title"></div>
                      <div class="descs" v-html="item.desc"></div>
                    </div>

                    <!-- <BtnDownload v-if="i === 1" class="app-signup__btn btn-download btn-download-1" /> -->
                  </li>
                </ul>
              </div>

              <div style="text-align: center">
                <BtnDownload
                  :diy="true"
                  class="app-signup__btn btn-download btn-download-1"
                  @click="goDownload"
                />
              </div>

              <div class="app-signup-tip">
                <a
                  href="https://crm2.qq.com/page/portalpage/wpa.php?uin=800185710&cref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa&ref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa%2Fstyle%26id%3Dwpa_setting_a01&pt=undefined&f=1&ty=1&ap=&as=&aty=0&a="
                  target="_blank"
                >
                  <img src="../../assets/kefu.png"><span>如有疑问点此联系客服</span>
                </a>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import jump from 'jump.js'
import dayjs from 'dayjs'
import BtnDownload from '../BtnDownload'
import { signUp, queryApplyInfo } from "@/api";

export default {
  components: {
    BtnDownload
  },
  props: {
    user: [Object]
  },
  data() {
    return {
      visible: false,
      checked: false,
      phone: "",
      name: "",
      complete: false,
      submited: false,
      message: "",
      options: [
        { value: 1, label: "0年" },
        { value: 2, label: "1年以内" },
        { value: 3, label: "1~3年" },
        { value: 4, label: "3~5年" },
        { value: 5, label: "5年以上" }
      ],
      steps: [
        {
          done: false,
          title: '报名成功',
          desc: ''
        },
        {
          done: false,
          title: '下载交易侠，并使用<strong>报名的手机号码</strong>进行注册登录，开通上金所帐户。',
          desc: ''
        },
        {
          done: false,
          title: '在交易侠成功入金，即可实盘交易PK',
          desc: ''
        }
      ]
    };
  },
  mounted() {
    this.$bus.$on("modalChange", changed => {
      if (changed) {
        if (this.user) {
          this.checkApplyInfo()
        } else {
          this.visible = changed
        }
        this.complete = false;
      } else {
        this.visible = changed
      }
    });
  },
  methods: {
    submit() {
      if (!/^1[3-9]\d{9}$/.test(this.phone)) {
        let msg = "请填写正确的联系电话";
        if (!this.phone.trim()) {
          msg = "请填写联系电话";
        }
        return this.$toast.open({
          message: msg,
          position: "top",
          type: "error"
        });
      }

      if (this.name.trim() === "") {
        return this.$toast.open({
          message: "请填写姓名",
          position: "top",
          type: "error"
        })
      }

      if (!this.checked) {
        return this.$toast.open({
          message: "请先勾选用户协议及隐私政策",
          position: "top",
          type: "error"
        });
      }

      this.signUp()
    },
    signUp () {
      window._czc.push(['_trackEvent', '点击', '提交报名信息']);

      signUp({
        mobile: this.phone,
        name: this.name
      })
        .then(res => {
          if (res.status === 500) {
            return this.$toast.open({
              message: res.message,
              position: "top",
              type: "error"
            });
          }

          if (!this.user) {
            this.steps[0].done = true
            this.steps[0].title = '报名成功'
            this.steps[0].desc = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
          } else {
            this.changeResult(res)
          }

          this.complete = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkApplyInfo (cb) {
      if (this.user) {
        queryApplyInfo({}).then(res => {
          // 未报名
          if (res.status === 4007) {
            this.visible = true
          } else {
            this.visible = true
            this.complete = true
            this.changeResult(res)
          }

          if (typeof cb === 'function') {
            cb.call(this, res)
          }
        })
      } else {
        this.signUp()
      }
    },
    changeResult (res) {
      // 没有交易编码，均属于报名成功
      if ([200, 4001, 4002, 4006].indexOf(res.status) > -1) {
        this.steps[0].done = true
        this.steps[0].title = '报名成功'
        this.steps[0].desc = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
      } else if ([4003, 4004].indexOf(res.status) > -1) {
        this.steps[0].done = true
        this.steps[0].title = '报名成功'
        this.steps[0].desc = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')

        this.steps[1].done = true
        this.steps[1].title = '开户成功'
        this.steps[1].desc = '下载交易侠，并使用<strong>报名的手机号码</strong>进行注册登录。开通上金所帐户。'
      } else if (res.status === 4005) {
        this.steps[0].done = true
        this.steps[0].title = '报名成功'
        this.steps[0].desc = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')

        this.steps[1].done = true
        this.steps[1].title = '开户成功'
        this.steps[1].desc = '下载交易侠，并使用<strong>报名的手机号码</strong>进行注册登录。开通上金所帐户。'

        this.steps[2].done = true
        this.steps[2].title = '入金成功'
        this.steps[2].desc = '在交易侠成功入金，即可实盘交易PK'
      }
    },
    onCheckboxChange() {
      this.checked = !this.checked;
    },
    onVisibleChange() {
      this.visible = !this.visible;
      if (this.visible) {
        this.checked = false
        this.phone = ""
        this.name = ""
      }
    },
    showLogin() {
      window._czc.push(['_trackEvent', '点击', '已报名点此登录']);
      this.$bus.$emit('showLogin', () => {
        this.checkApplyInfo()
      })
    },
    goDownload() {
      this.visible = false
      this.$nextTick(() => {
        this.$bus.$emit('showDownload')
        jump('.app-topic__signin', {
          duration: 500
        })
      })
    }
  }
};
</script>

<style lang="scss">
.app-signup {
  &-flow {
    .title {
      strong {
        color: #E7B7AF;
      }
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.app-signup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  overflow: hidden;

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.8;
  }

  &__close {
    position: absolute;
    right: 0;
    top: 10px;
    width: 24px;
    height: 24px;
    background: url(../../assets/icon-close.png) center/cover no-repeat;
    cursor: pointer;
  }

  &-flow {
    color: #E7B7AF;
    font-size: 16px;
    line-height: 24px;

    ul {
      display: block;
      width: 75%;
      margin: 0 auto;
    }

    li {
      position: relative;
      display: flex;
      align-items: center;
      padding: 24px 0;

      .btn-download-1 {
        position: absolute;
        display: block;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        width: 30%;
      }

      &.done {
        .title {
          color: #E7B7AF;
        }
      }

      &:nth-last-child(1) {
        &::after {
          display: none;
        }
      }

      &:nth-of-type(1) {
        &::before {
          display: none;
        }
      }

      .order-num, .icon-done {
        position: relative;
        z-index: 9;
        display: block;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-weight: 500;
        margin-right: 10px;
        font-size: 24px;
        line-height: 40px;
      }

      .icon-done {
        background: url("../../assets/icon-checkbox.png") center/contain no-repeat;
      }

      .title {
        font-weight: 500;
        color: #D88577;

        strong {
          color: #E7B7AF;
        }
      }
      &::before, &::after {
        content: "";
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 18px;
        width: 3px;
        height: 50%;
        background: #78462b;
      }
      &::before {
        top: 0;
      }
      &.done {
        &::after, &::before {
          background: #78462b;
        }
      }
    }
  }

  &-tip {
    position: relative;
    padding: 10px 0 4px;
    margin-bottom: percentage(18px / 600px);
    text-align: center;
    font-size: 12px;
    color: #E7B7AF;
    line-height: 20px;

    a {
      color: #E7B7AF;
    }
    
    img {
      width: 16px;
      margin-right: 6px;
      vertical-align: middle;
    }
    span {
      display: inline-block;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -60px;
      width: 120px;
      height: 1px;
      background: linear-gradient(270deg,rgba(191,134,123,0) 0%,rgba(154,110,101,0.6) 25%,rgba(114,74,66,0.6) 72%,rgba(90,53,46,0.1) 100%);;
    }
  }

  .box {
    background: transparent;
    opacity: 1;
    overflow: hidden;
  }

  .form {
    width: percentage(360px / 600px);
    margin: percentage(10px / 600px) auto 0;

    &-item {
      margin: percentage(20px / 600px) 0;
      display: flex;

      i {
        font-size: 14px;
        color: #ebc4bc;
        font-style: normal;
        padding: 0 4px 0 2px;
      }

      &__label,
      &__control {
        white-space: nowrap;
        display: inline-block;
      }

      &__label {
        width: 80px;
        font-size: 16px;
        color: #ebc4bc;
        line-height: 27px;
        text-align: right;
        margin-right: 8px;
        white-space: pre;
      }

      &__control {
        flex: 1;
        background: url(../../assets/input.png) left center/100% 100% no-repeat;
      }

      input,
      select {
        background: transparent;
        border: none;
        width: 100%;
        height: 100%;
        color: #ebc4bc;
        padding: 0 16px;
        box-sizing: border-box;

        &:focus,
        &:active {
          outline: none;
          box-shadow: none;
        }

        &:focus {
          background: url(../../assets/input-active.png) left center/100% 100%
            no-repeat;
        }
      }

      select {
        &:focus {
          background: none;
        }
      }
    }
  }

  &__btn {
    position: relative;
    display: inline-block;
    width: percentage(160px / 600px);
    padding-top: percentage(42px / 600px);
    @include image-2x(
      "../../assets/aside-btn-active@1x.png",
      center top,
      no-repeat,
      100% 100%
    );

    &.app-signup__btn-login {
      margin-left: 10px;
      width: percentage(170px / 600px);
    }

    span, /deep/span {
      @include middle();
      color: #ebc4bc;
      font-size: 16px;
      white-space: nowrap;
    }

    &.btn-download {
      width: percentage(142px / 600px);
      padding-top: percentage(45px / 600px);
      margin: percentage(28px / 600px) auto 0;
      @include image-2x(
        "../../assets/aside-btn-2@1x.png",
        center top,
        no-repeat,
        100% 100%
      );

      span, /deep/span {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }

  .btn-wrap {
    position: relative;
    width: percentage(446px / 600px);
    margin: percentage(32px / 600px) auto percentage(54px / 600px);
    text-align: center;
    vertical-align: middle;

    .app-signup__btn-login {
      margin-top: percentage(34px / 600px);
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ebc4bc;
      cursor: pointer;
      img {
        margin-left: 4px;
        vertical-align: middle;
      }
    }
  }

  &__tip {
    margin: 0 auto;
    width: percentage(446px / 600px);
    text-align: center;
    font-size: 12px;
    color: #784440;
    line-height: 22px;
    white-space: nowrap;
    a {
      color: #c3a39d;
      cursor: pointer;
      &:hover {
        color: #ebc4bc;
      }
    }

    span {
      vertical-align: middle;
    }

    &__checkbox {
      position: relative;
      margin-right: 3px;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(../../assets/num-bg-normal.png) center/contain no-repeat;
      cursor: pointer;

      i {
        position: absolute;
        top: 0;
        left: 50%;
        display: block;
        margin-top: 4px;
        width: 4px;
        height: 8px;
        border-style: solid;
        border-color: #784440;
        border-color: transparent;
        border-width: 0 2px 2px 0;
        transform: translate(-50%, 0) rotateZ(45deg);
      }

      &.app-signup__tip__checkbox--checked {
        background: url(../../assets/num-bg-fill.png) center/contain no-repeat;

        i {
          border-color: #ebc4bc;
        }
      }
    }
  }

  &__topic {
    margin: percentage(18px / 600px) auto 0;
    width: percentage(100px / 600px);
    display: block;
  }

  &-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: percentage(600px / $baseWidth);
    min-width: 600px;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);
      width: percentage(120px / 600px);
      padding-top: percentage(90px / 600px);
      background: url(../../assets/topic-img.png) center/contain no-repeat;
    }
  }

  /deep/.select {
    width: 100%;
    height: 100%;
    margin: 0;

    .select-input {
      width: 100%;
      height: 100%;
      border: none;
      padding: 0 16px;
      color: #ebc4bc;
      font-size: 12px;
    }

    .placeholder {
      font-size: 12px;
      color: #747474;
    }
  }
}

@media screen and (min-width: 1440px) {
  .app-signup {
    &-flow {
      font-size: 16px;
      line-height: 24px;

      li {
        &::before {
          top: 0;
        }

        &.done {
          .title {
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media screen and(min-width: 779px) {
  .app-signup {
    &-container {
      background: none;
      background-image: none;
      @include image-2x(
        "../../assets/signup-bg@1x.png",
        center top,
        no-repeat,
        100% 100%
      );

      &.complete {
        @include image-2x(
          "../../assets/signup-bg@1x.png",
          center top,
          no-repeat,
          100% 100%
        );
      }
    }

    &__close {
      right: percentage(52px / 600px);
    }
  }
}

@include mobile {
  .app-signup {
    &-container {
      width: percentage(374px / 414px);
      min-width: auto;
      max-width: 540px;
      background: rgba(23, 19, 20, 1);
      border-radius: 8px;
      border: 2px solid;
      border-image: linear-gradient(
          360deg,
          rgba(134, 76, 46, 0.26),
          rgba(134, 76, 46, 0.52),
          rgba(134, 76, 46, 0.46),
          rgba(134, 76, 46, 1),
          rgba(134, 76, 46, 0.2)
        )
        2 2;

      &::after {
        content: "";
        transform: translate(-50%, -100%);
        width: percentage(100px / 374px);
        padding-top: percentage(75px / 374px);
        background: url(../../assets/topic-img.png) center/contain no-repeat;
      }
    }

    &__topic {
      width: percentage(86px / 374px);
    }

    &-flow {
      .order-num, .icon-done {
        width: 24px !important;
        height: 24px !important;
        line-height: 24px !important;
      }
      li {
        &::before, &::after {
          content: "";
          left: 11px;
        }
      }
    }

    .btn-wrap {
      position: relative;
      width: percentage(446px / 600px);
      margin: percentage(32px / 600px) auto percentage(54px / 600px);
      text-align: center;
      vertical-align: middle;

      .app-signup__btn-login {
        position: relative;
        display: block;
        font-size: 12px;
        margin-top: 10px;
      }
    }

    .form {
      width: percentage(360px / 374px);

      &-item__label {
        font-size: 14px;
        width: 70px;
        line-height: 32px;
        margin-right: 2px;
      }
    }

    &__tip {
      width: percentage(399px / 414px);
      white-space: normal;
    }

    &__close {
      width: 20px;
      height: 20px;
      right: 10px;
    }

    &__btn {
      width: percentage(180px / 374px);
      padding-top: percentage(37px / 374px);

      &.btn-download {
        width: percentage(140px / 374px);
        padding-top: percentage(37px / 374px);
      }
    }
  }
}
</style>
